import actions from './actions';
import mutations from './mutations';

const state = {
    host: '',
    userPlantData: {
        doFertilizer: false,
        doReplant: false,
        doWater: false, // 帮好友浇水
        fullMature: '',
        lastMaturityTime: 0,
        plant: {
            description: '',
            flowerCount: 0,
            heartCountPerPeriod: 0, // 每个生长周期的爱心产出
            imagesContent: [],
            levelThreshold: 0, // 等级解锁要求
            maturitySecondsPerHeart: 0, // 成熟周期
            name: '',
            plantId: 0,
            requireVip: false,
            host: '',
        },
        productions: {
            hearts: [],
        },
        fertilization: {
            defaultScale: 0,
            everFertilized: false,
            fertilizationScale: 0,
            fertilized: false,
            fertilizationDurationSeconds: 0,
            fertilizePrice: 0,
            fertilizerCountDownSeconds: 0,
            heartThresholdWhenPickup: 0,
            minimumFertilizationRenewalSeconds: 0,
            fertilizationEndDate: '', // 字符串格式
            fertilizationEndTime: 0, // 时间戳
        },
        userId: -1,
        nextHeartProduction: 0,
        newUserHeart: {},
        triggerPage: '', // 触发页面（对方花园打点使用）
    },
    userDetail: {
        albumCount: 0,
        collectedSubjectList: [],
        info: {
            avatarUrl: '',
            cardCount: 0,
            level: 22,
            nickname: '',
            popularValue: 0,
            userId: -1,
            userRoleMark: 0,
            vipStatus: -1,
        },
        recentSubject: {
            imageUrl: '',
            subjectId: 0,
            subjectName: '',
        },
        socialStatus: 0, // 社交关注状态，0 - 未关注，1 - 已关注，2 - 被关注，3 - 互相关注
    },
    drawRecordData: {},
};

export default {
    namespaced: true,
    state,
    mutations,
    actions,
};
